<script setup>
    import query from '~/graphql/page-content'
    import { useContentful } from "~/composables/useContentful.js";
    const props = defineProps({
        data: {
            type: Object,
            required: false,
        },
    });
    const route = useRoute();

    const routeName = route.path;
    const runtimeConfig = useRuntimeConfig()
    const router = useRouter()


    const contentful = useContentful();


    // const screenSize = reactive({
    //   width: window.innerWidth
    // })
    // const updateScrensize = () => {
    //   screenSize.width = window.innerWidth
    //   const sideMenu = document.querySelector('.astronaut-sidebar')
    //   sideMenu.style.position = '';
    //   if (screenSize.width > 961) {
    //     window.addEventListener('scroll', () => {
    //       if (document.documentElement.scrollTop > 1000) {
    //         sideMenu.style.position = '';
    //       }
    //       else {

    //         sideMenu.style.position = 'fixed';
    //       }
    //     });
    //   }
    // }
    //   onBeforeUnmount(() => {
    //     window.removeEventListener('resize', updateScrensize)

    // })
    onMounted(async () => {
        // window.addEventListener('resize', updateScrensize)

    });




    const isOpenMenu = ref(false);
    const handleOpenMenu = () => {
        isOpenMenu.value = !isOpenMenu.value;
    }
</script>

<template>
    <div :class="['modular-side-content']">
     
        <aside :class="['astronaut-sidebar']">
            <div class="profile-section">
                <div class="astronaut-info">
                    <div class="info-container">
                        <ContentfulRichText v-if="data.sidebarCopy" :json="data.sidebarCopy.json" />
                        <h2 v-else>The Virgin Galactic Experiences</h2>

                        <p class="member-date-empty"></p>

                        <div class="country-flag"></div>
                        <div class="grd-divider"></div>
                        <div class="main-info-container">

                            <div v-if="data.contactName || data.contactEmail || data.contactNumber">
                                <div v-if="data.contactName" class="info-line" style="background-image: none;">
                                    <p>{{data.contactName}}</p>
                                </div>
                                <div class="info-line" v-if="data.contactEmail">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="white" aria-label="Contact Email Icon" aria-labelledby="contactEmailIcon contactEmailIconDesc" role="img">
                                        <title id="contactEmailIcon">Contact Email Icon</title>
                                        <desc id="contactEmailIconDesc">An illustrated Contact Email Icon.</desc>
                                        <path
                                            d="M2 4h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v.01L12 13l10-6.99V6H2zm20 2.08L12 15 2 8.08V18h20V8.08z" />
                                    </svg>
                                    <p style="margin-left:6px"><a
                                            :href="`mailto:${data.contactEmail}`">{{data.contactEmail}}</a></p>
                                </div>
                                <div class="info-line" v-if="data.contactNumber">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="white" aria-label="Contact Number Icon" aria-labelledby="contactNumberIcon contactNumberIconDesc" role="img">
                                        <title id="contactNumberIcon">Contact Number Icon</title>
                                        <desc id="contactNumberIconDesc">An illustrated Contact Number Icon.</desc>
                                        <path
                                            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.16 19.47 19.47 0 0 1-6-6A19.86 19.86 0 0 1 3.1 4.18 2 2 0 0 1 5 2h3a2 2 0 0 1 2 1.72 12.05 12.05 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11l-1.27 1.27a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.05 12.05 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                    </svg>
                                    <p style="margin-left:6px">{{data.contactNumber}}</p>
                                </div>
                            </div>
                            <!---- <div style="padding: 5px;">

                                <p >Giorgio Manenti</p>
                                <p>
                                    <Icon name="mail" style="margin-top: 1px;" />
                                    your.name@email.com
                                </p>

                                <p>
                                    <Icon name="phone" />
                                    +1 555 867-5309
                                </p>

                            </div> -->
                        </div>
                        <p v-if="data.contactName || data.contactEmail || data.contactNumber" class="member-date-empty">
                        </p>

                        <div v-if="data.contactName || data.contactEmail || data.contactNumber" class="country-flag">
                        </div>
                        <div v-if="data.contactName || data.contactEmail || data.contactNumber" class="grd-divider">
                        </div>
                        <br v-if="data.contactName || data.contactEmail || data.contactNumber">
                        <div class="info-container" v-if="data.link">
                            <a :href="data.link" style="color: #ffffff; text-decoration: underline; ">Click here for
                                more
                                info</a>

                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <!--<nav class="menu">
                <ul>
                    <li>
                        <NuxtLink :to="'/members/'">
                            {{navItem.label}}
                        </NuxtLink>
                    </li>
                    <li>
                    </li>
                    <li>
                        <NuxtLink to="/members/profile">
                            My Profile
                        </NuxtLink>
                    </li>

                </ul>
            </nav>-->
        </aside>
    </div>
</template>

<style lang="scss">
    @import '~/styles/vendors/sass-mq/mq';
    @import '~/styles/utils/functions';

    .main-info-container {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        max-width: 500px;
        margin: 20px auto;
    }

    /* .main-icon-container {
        flex-shrink: 0;
        background-image: none;
    } */

    /* .main-icon {
        width: 60px;
        height: 60px;
    } */

    .info-container {
        text-align: center;
    }

    .info-line {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        /* Spacing between lines */
    }

    .info-line a {
        transition: 0.3s;
        color: #ffffff;
        text-decoration: underline;
    }

    /* .detail-display {
        margin-left: 6px;
    }

    .line-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    } */

    .info-line p {
        margin: 0;
        line-height: 1.5;
    }

    /* .date-link span {
        color: #b100eb;
    } */

    .astronaut-sidebar h2 {
        text-transform: uppercase;
    }

    .astronaut-sidebar .menu {
        text-transform: uppercase;
    }

    .astronaut-sidebar .menu .router-link-exact-active {
        color: #ffffff;
    }

    .astronaut-sidebar .menu ul li {
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .astronaut-sidebar .menu a {
        color: #939393;
    }

    .astronaut-info {
        padding: 2em 2em 2em 0;
        position: relative;
    }

    .country-flag {
        position: absolute;
        top: 3.5em;
        right: 3em;
    }
    @media (max-width:961px) {
        .astronaut-sidebar {

        margin: 0 auto;
            width: 100%;

            @include mq($from: 'm') using ($from) {
                max-width: gs(5, 4, 'xxxs');
            }

            @include mq($from: 'l') using ($from) {
                max-width: gs(18, 17, 'l');
            }
        }

    }
    @media (min-width:962px) {
        .astronaut-sidebar {
            width: 26%;
            overflow: hidden;
            position: fixed;

        }

        .country-flag {
            right: 3em;
            top: 1.5em;
        }

        .astronaut-info {
            padding: 0 2em 0 0;
            overflow-y: auto;
            word-break: break-all;
            overflow-wrap: break-word;

        }
    }

    .astronaut-info {
        padding: 1em;
        border-top-left-radius: 2em;
        -moz-border-radius-topleft: 2em;
        background-image: linear-gradient(90deg,
                hsl(267deg 73% 32%) 0%,
                hsl(266deg 73% 30%) 6%,
                hsl(265deg 73% 29%) 11%,
                hsl(264deg 73% 28%) 16%,
                hsl(263deg 73% 27%) 21%,
                hsl(262deg 73% 26%) 26%,
                hsl(261deg 73% 24%) 32%,
                hsl(262deg 73% 22%) 38%,
                hsl(263deg 74% 20%) 45%,
                hsl(264deg 75% 18%) 53%,
                hsl(265deg 76% 16%) 62%,
                hsl(265deg 77% 14%) 75%,
                hsl(266deg 77% 12%) 100%);
    }

    .grd-divider {
        margin: 0.5em auto;
        height: 0.15em;
        width: 100%;
        background-image: linear-gradient(90deg,
                hsl(245deg 100% 72%) 0%,
                hsl(252deg 100% 71%) 10%,
                hsl(260deg 100% 69%) 20%,
                hsl(263deg 65% 56%) 30%,
                hsl(264deg 57% 35%) 40%,
                hsl(263deg 81% 16%) 50%,
                hsl(262deg 82% 15%) 60%,
                hsl(261deg 86% 13%) 70%,
                hsl(225deg 62% 25%) 80%,
                hsl(200deg 100% 37%) 90%,
                hsl(189deg 100% 50%) 100%);
    }

    .member-date {
        margin-top: -16px;
    }

    .member-date-empty {
        margin-top: 30px;
    }

    @media screen and (max-width: 961px) {
        .member-since {
            margin-top: -26px;
        }

        .member-date {
            margin-right: -100px;
            margin-top: 9px;
        }
    }
</style>